<!-- eslint-disable import/no-unresolved no-unused-vars -->
<script>
import { ref } from 'vue';
import kebabCase from 'lodash-es/kebabCase';
import statistic from '@/components/flexible/sections/statistic.vue';
import quoteBig from '@/components/flexible/sections/quoteBig.vue';
import quoteSmall from '@/components/flexible/sections/quoteSmall.vue';
import featuredContent from '@/components/flexible/sections/featuredContent.vue';
import msDynamicsFormSection from '@/components/flexible/sections/msDynamicsFormSection.vue';
import ad from '@/components/flexible/sections/ad.vue';
import Medias from '@/components/flexible/medias/Medias.vue';
import wysiwyg from '@/components/wysiwyg/Wysiwyg.vue';
import PodcastEmbedded from '@/components/podcast/PodcastEmbedded.vue';
import featuredPostBanner from '@/components/featured-post-banner/FeaturedPostBanner.vue';
import accordions from '@/components/accordions/AccordionsFlexible.vue';
import featuredPosts from '@/components/featured-posts/FeaturedPosts.vue';
import featuredPostsRelatedTo from '@/components/featured-posts/FeaturedPostsRelatedTo.vue';
import featuredPostsGrid from '@/components/flexible/sections/featuredPostsGrid.vue';
import featuredPostsGridRelatedTo from '@/components/flexible/sections/featuredPostsGridRelatedTo.vue';
import sentierDesActualites from '@/components/flexible/home/sentierDesActualites.vue';
import sentierDeLaGastronomie from '@/components/flexible/home/sentierDeLaGastronomie.vue';
import sentierDesDecouvertes from '@/components/flexible/home/sentierDesDecouvertes.vue';
import sentierDesEconomies from '@/components/flexible/home/sentierDesEconomies.vue';
import newsletter from '@/components/newsletter/Newsletter.vue';
import productSelection from '@/components/flexible/sections/productSelection.vue';
import faq from '@/components/flexible/sections/faq.vue';
import discountsSelection from '@/components/flexible/sections/discountsSelection.vue';
import discountsRelatedTo from '@/components/flexible/sections/discountsRelatedTo.vue';
import bioCta from '@/components/bio-cta/BioCta.vue';
import sentierDeLAgrotourisme from '@/components/flexible/home/sentierDeLAgrotourisme.vue';
import newsletterBoxed from '@/components/newsletter/NewsletterBoxed.vue';
import mapGroceries from '@/pages/location/LocationSaleSpecialist.vue';
import mailchimpForm from '@/components/flexible/sections/flexibleMailchimpForm.vue';

export default {
    name: 'Flexible',
    components: {
        wysiwyg,
        statistic,
        Medias,
        quoteBig,
        quoteSmall,
        featuredContent,
        msDynamicsFormSection,
        PodcastEmbedded,
        ad,
        featuredPosts,
        featuredPostsRelatedTo,
        accordions,
        featuredPostBanner,
        featuredPostsGrid,
        featuredPostsGridRelatedTo,
        sentierDesActualites,
        sentierDeLaGastronomie,
        sentierDesDecouvertes,
        sentierDesEconomies,
        newsletter,
        productSelection,
        faq,
        discountsSelection,
        discountsRelatedTo,
        bioCta,
        sentierDeLAgrotourisme,
        newsletterBoxed,
        mapGroceries,
        mailchimpForm,
    },
    props: {
        data: { type: Object, default: () => {} },
        coverColor: {
            type: String,
            default: '',
        },
        color: {
            type: String,
            default: '',
        },
        themeColor: {
            type: String,
            default: '',
        },
        mainColor: {
            type: String,
            default: '',
        },
        adFilters: { type: Object, default: () => {} },
        removeSpaceBottom: { type: Boolean, default: false },
    },
    emits: ['flexibleReady'],
    async setup(props, { emit }) {
        const blocks = ref([]);
        const cleanTypename = (str) => str.split('_')[1];

        await Promise.all(
            props.data.map(async (d, i) => {
                const type = cleanTypename(d.__typename);
                const isMedia = ['imageImage', 'imageCredits', 'imageVideo', 'podcastImage', 'image', 'video'].indexOf(type) > -1;
                const isAd = ['adSpace', 'ad'].indexOf(type) > -1;
                const noPadding =
                    [
                        'sentierDesActualites',
                        'sentierDeLaGastronomie',
                        'sentierDesDecouvertes',
                        'sentierDesEconomies',
                        'sentierDeLAgrotourisme',
                        'newsletter',
                        'faq',
                        'bioCta',
                    ].indexOf(type) > -1;

                blocks.value.push({
                    isMedia,
                    isAd,
                    type,
                    data: d,
                    noPadding,
                    adFilters: props.adFilters,
                    anchor: kebabCase(d.anchorTitle ?? type + i),
                });
            }),
        );

        emit('flexibleReady');

        return { blocks };
    },
};
</script>

<template>
    <div class="Flexible">
        <template
            v-for="(block, index) in blocks"
            :key="block.type + index"
        >
            <div
                :id="block.anchor"
                class="Flexible__section mt-px"
                :class="[
                    'is-type-' + block.type,
                    {
                        'pt-8': !block.noPadding,
                        'pb-0': removeSpaceBottom,
                        'pb-4 md:pb-8': !removeSpaceBottom && !block.noPadding,
                        '!p-0': block.type == 'ad' || block.type == 'adSpace',
                    },
                ]"
            >
                <Medias
                    v-if="block.isMedia"
                    :theme-color="themeColor"
                    :cover-color="coverColor"
                    :data="block"
                    :main-color="mainColor"
                />
                <ad
                    v-else-if="block.isAd"
                    :theme-color="themeColor"
                    :color="color"
                    :data="block"
                    :main-color="mainColor"
                />
                <component
                    :is="block.type"
                    v-else
                    :color="color"
                    :theme-color="themeColor"
                    :data="block"
                    :main-color="mainColor"
                />
            </div>
        </template>
    </div>
</template>
